import React from 'react';
import { parseDiscountItem } from '../../../../../utils/helpers';

import { Text } from '../../../../typography/text/Text';
import styles from '../CartItem.module.scss';

const CartPromotion = ({ data }) => {
  if (!data) return;

  const { name, color, bgColor } = parseDiscountItem(data);

  return name && (
    <div
      className={styles.cartPromotion}
      style={{
        color: color,
        backgroundColor: bgColor
      }}
    >
      <Text
        as="span"
        size="s"
        weight="semibold"
        textTransform="uppercase"
        align="center"
      >
        {name}
      </Text>
    </div>
  );
};

export default CartPromotion;
